import React from "react";
import {
    Box,
    Circle,
    Flex,
    Heading,
    HStack,
    Icon,
    SimpleGrid,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import {MdOpenInNew, MdSettings} from "react-icons/md";

// Site to open from the shortcut tile.
const SHORTCUT_URL = "https://demo.digitalghanti.com/#/admin/bell-dashboard";

function SettingsMenu() {
    const cardBg = useColorModeValue("white", "gray.700");
    const pageBg = useColorModeValue("gray.50", "gray.800");
    const subText = useColorModeValue("gray.600", "gray.300");

    const openShortcut = () => {
        window.open(SHORTCUT_URL, "_blank", "noopener,noreferrer");
    };

    const tiles = [
        {
            icon: MdOpenInNew,
            title: "Bell Dashboard Shortcut",
            text: "Open the Bell Dashboard in a new tab.",
            color: "teal",
            onClick: openShortcut,
        },
    ];

    return (
        <Flex
            direction="column"
            pt={{base: "110px", md: "80px"}}
            px={{base: "4", md: "8"}}
            pb="10"
            bg={pageBg}
            minH="100vh"
        >
            <Box mb={6}>
                <HStack spacing={3} mb={1}>
                    <Icon as={MdSettings} boxSize="26px" color="teal.500"/>
                    <Heading size="lg">Settings</Heading>
                </HStack>
                <Text color={subText}>Manage shortcuts and preferences for Digital Ghanti.</Text>
            </Box>

            <SimpleGrid columns={{base: 1, md: 2, lg: 3}} spacing={5}>
                {tiles.map((tile) => (
                    <Box
                        key={tile.title}
                        as="button"
                        textAlign="left"
                        onClick={tile.onClick}
                        bg={cardBg}
                        p={6}
                        borderRadius="16px"
                        boxShadow="sm"
                        border="1px solid"
                        borderColor="gray.100"
                        transition="all 0.22s ease"
                        _hover={{
                            transform: "translateY(-6px)",
                            boxShadow: "xl",
                            borderColor: `${tile.color}.200`,
                        }}
                        role="group"
                    >
                        <Circle
                            size="52px"
                            bg={`${tile.color}.50`}
                            color={`${tile.color}.500`}
                            mb={4}
                            transition="all 0.22s ease"
                            _groupHover={{bg: `${tile.color}.500`, color: "white"}}
                        >
                            <Icon as={tile.icon} boxSize="26px"/>
                        </Circle>
                        <Heading size="sm" mb={2}>{tile.title}</Heading>
                        <Text color={subText} fontSize="sm">{tile.text}</Text>
                    </Box>
                ))}
            </SimpleGrid>
        </Flex>
    );
}

export default SettingsMenu;
